module.exports = __webpack_public_path__ + "img/hotel6.96df8b8e.png";